module.exports = __webpack_public_path__ + "img/olc-screen-olc-2.55eee4fc.jpg";